import {useCallback, useRef, useState} from 'react';

import {useParentLookupMutation} from '~/store/rtkQuery';
import {ParentLookupState} from './parentLookupState';

export const useParentLookup = () => {
  const [parentLookupTrigger] = useParentLookupMutation();
  const [parentLookup, setParentLookup] = useState<ParentLookupState>({
    status: 'idle',
  });
  const latestRequestId = useRef(0);

  const search = useCallback(
    async (query: string) => {
      const trimmedQuery = query.trim();
      if (!trimmedQuery) {
        return;
      }

      const requestId = ++latestRequestId.current;
      setParentLookup({status: 'searching'});

      const response = await parentLookupTrigger({query: trimmedQuery});

      if (requestId !== latestRequestId.current) {
        return;
      }

      if ('error' in response) {
        setParentLookup({
          status: 'error',
          message: response.error?.message ?? 'Search failed',
        });
      } else {
        setParentLookup({
          status: 'found',
          parentUserId: response.data.userId,
          parentInfo: response.data,
        });
      }
    },
    [parentLookupTrigger],
  );

  const reset = useCallback(() => {
    latestRequestId.current++;
    setParentLookup({status: 'idle'});
  }, []);

  return {parentLookup, search, reset};
};
